
export const duo_info = 'Duo MFA helps to ensure that malicious actors don\'t gain access to your account with us even if your password is compromised.'

export const duo_md = `
# Duo Multi-factor Authentication (MFA)
*Last updated on August 12, 2025*

## Overview

Duo multi-factor authentication (MFA) makes it harder for unauthorized users to gain access to your account by requiring an additional verification step in addition to a password when you attempt to log into your account. 
After entering your password, you will be prompted to verify your identity using the Duo app, or by using a passcode from a token or fob. 
This step allows you to acknowledge and approve every log in attempt to your account.

Please note that Duo is only as effective as you make it. 
Approving push notifications or providing a passcode for login attempts that were not initiated by you will result in your account being breached. 
Do not approve suspicious Duo push notifications.

## Benefits
- Helps prevent unauthorized users from accessing your account in the event of a password breach.
- Enhances your protection against phishing attempts.
- Ensures only trusted devices access our network resources.
- Helps to safeguard all of the data you have behind your login.

## Requirements
- An iOS or Android device that supports the Duo mobile app (recommended)
- Or a USB token or fob (this can be provided upon request)

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)

`